import { IconArrowLeft as TablerIconArrowLeft } from '@tabler/icons-react';

import { createOutlineIcon } from '@/components/icon/createOutlineIcon';

export const IconArrowLeft = /*#__PURE__*/ createOutlineIcon(TablerIconArrowLeft, 'IconArrowLeft');
